import Image from 'next/image';
import { ArrowRight } from 'lucide-react';
import { SvgIcon } from '@/components/shared/SvgIcon';

import { getDotcmsImageURL } from '@/app/utils/getDotcmsImageURL';

export function DemoCard({ demo }) {
    const thumbSrc = demo.thumbnail?.idPath ?? demo.thumbnail?.identifier ?? demo.thumbnail;

    return (
        <a
            href={`/demo-center/${demo.urlTitle}`}
            className="group relative flex flex-col overflow-hidden rounded-3xl border border-blue-200 bg-white p-2 transition duration-300 hover:-translate-y-1 hover:border-fuschia-700/30 hover:shadow-[0_30px_60px_-25px_rgba(182,38,232,0.35)]">
            <div className="relative aspect-[16/10] overflow-hidden rounded-2xl bg-gray-100">
                {thumbSrc && (
                    <Image
                        src={getDotcmsImageURL({ src: thumbSrc, width: 600 })}
                        alt={demo.title}
                        fill
                        className="object-cover"
                        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                    />
                )}
                <div className="absolute left-2 top-2 flex size-10 items-center justify-center rounded-xl bg-white/80 shadow backdrop-blur-md">
                    <SvgIcon icon={demo.demoIcon} size={20} className="text-blue-700" />
                </div>
                <span className="absolute right-2 top-2 rounded-full bg-black/10 px-2.5 py-1 text-xs font-semibold uppercase tracking-wider text-blue-700 backdrop-blur-md">
                    {demo.category}
                </span>
            </div>

            <div className="flex flex-1 flex-col px-4 py-5">
                <h3 className="text-xl font-semibold tracking-tight text-blue-700">{demo.title}</h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-blue-500">
                    {demo.description}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-blue-100 pt-4">
                    <span className="text-xs font-medium uppercase tracking-wider text-blue-500">
                        {demo.duration}
                    </span>
                    <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary transition group-hover:gap-2.5">
                        Launch Tour
                        <ArrowRight className="size-4" />
                    </span>
                </div>
            </div>
        </a>
    );
}
